import { ArrowBack } from '@mui/icons-material';
import { Container, IconButton, Paper, Typography } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { HOME_PATH } from 'src/constants';
import QueuedUploaderManager from '../components/QueuedUploader/QueuedUploaderManager';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: theme.palette.background.default,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(4),
    marginTop: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
    color: theme.palette.primary.main,
  },
  description: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  backButton: {
    marginRight: theme.spacing(2),
    alignSelf: 'center',
  },
}));

export default function UploadPage(): ReactElement {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleBack = (): void => {
    navigate({ to: HOME_PATH });
  };

  return (
    <>
      <Helmet>
        <title>Upload Media</title>
      </Helmet>
      <div className={classes.root}>
        <Container maxWidth="lg">
          <div className={classes.header}>
            <IconButton className={classes.backButton} onClick={handleBack} aria-label="back to library" size="large">
              <ArrowBack />
            </IconButton>
          </div>
          <Typography variant="h4" component="h1" className={classes.title}>
            Upload Media
          </Typography>
          <Typography variant="body1" className={classes.description}>
            Upload video files and add metadata. Files will be processed and added to your media library.
          </Typography>

          <Paper className={classes.paper} elevation={2}>
            <QueuedUploaderManager />
          </Paper>
        </Container>
      </div>
    </>
  );
}
